import { useEffect, useState } from "react";
import Vector from "../assets/Vector.svg";
import _, { template } from "lodash";
import { InputCheckboxGroup } from "../../../Forms/Fields/types/_FormCheckboxGroup";
import ContentResultManual from "./ContentResultManual";
import ContentSlider2Manual from "./ContentSlider2Manual/ContentSlider2Manual.js";
import { v4 as uuidv4 } from "uuid";
import getContentById from "../../../../utils/getContentById";
import { InputCheckboxSingle } from "../../../Forms/Fields/types/_FormSingleCheckbox";

const ContentTab = ({ form, selectedTemplate, templateData, manualEntries, setManualEntries, setTemplateData, presetBgColor, presetGkColor, effects }) => {
  const [activeSubTab, setActiveSubTab] = useState("Lineup");
  const fields = _.get(templateData, "data.fields", []);
  const [filteredField, setFilteredFields] = useState(fields?.find(
    (item) => item?.type === "checkbox-group" && item?.label === activeSubTab,
  ))

  const [heatmapField, setHeatmapFields] = useState(fields?.find(
    (item) => item?.type === "checkbox-single"
  ))

  useEffect(() => {
    const _originalFields = fields?.find(
      (item) => item?.type === "checkbox-group" && item?.label === activeSubTab,
    );
    if (manualEntries && manualEntries?.length > 0) {
      const updatedField = _.cloneDeep(_originalFields);
      const prevData = _.get(updatedField, 'data', []);
      prevData.push(...manualEntries);
      setFilteredFields(updatedField);
      // 
      // settemplatedata
    } else {
      setFilteredFields(_originalFields)
    }
  }, [fields, activeSubTab, manualEntries])

  const templateName = selectedTemplate?.template_name;


  // for line up
  const [playerNo, setPlayerNo] = useState(null);
  const [playerName, setPlayerName] = useState(null);

  const onNoChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setPlayerNo(value);
  }

  const onNameChange = (e) => {
    const value = e.target.value;
    setPlayerName(value)
  }

  const onAddNewPlayer = () => {
    const updated = [...manualEntries]?.filter((entry) => entry !== null)
    if (!playerNo || !playerName) return;
    const newItem = { shirtNumber: playerNo, shortLastName: playerName, id: uuidv4(), position: activeSubTab, type: 'manualPlayer' }
    updated.push(newItem);
    setManualEntries(updated);
    const updatedTemplate = _.cloneDeep(templateData);
    const prevAdditional = getContentById("additional_lineup", updatedTemplate.data.fields)
    prevAdditional.push(newItem);
    _.set(updatedTemplate, "data.fields.additional_lineup.value", prevAdditional)
    // setTemplateData(updatedTemplate);
  }


  return (
    <div>
      {selectedTemplate && templateName === "fcb_lineup" && (
        <div className="content-tab lineup-content">
          <div className="tab-switcher">
            <button
              type="button"
              className={`tab ${activeSubTab === "Lineup" ? "active" : ""}`}
              onClick={() => setActiveSubTab("Lineup")}
            >
              Lineup
            </button>
            <button
              type="button"
              className={`tab ${activeSubTab === "Reserve" ? "active" : ""}`}
              onClick={() => setActiveSubTab("Reserve")}
            >
              Substitute
            </button>
          </div>

          <div className="add-player-form">
            <input
              type="text"
              placeholder="No."
              className="small-input"
              onChange={onNoChange}
            />
            <input
              type="text"
              placeholder="Player name"
              className="player-input"
              onChange={onNameChange}
            />
            <button type="button" className="add-btn" onClick={onAddNewPlayer}>
              Add
            </button>
          </div>



          {/* Player list */}
          <div className="player-list-box">
            {filteredField?.id ?
              <InputCheckboxGroup
                key={filteredField?.id}
                item={filteredField}
                form={form}
                isCutoutModal={true}
                presetBgColor={presetBgColor}
                setFilteredFields={setFilteredFields}
                setTemplateData={setTemplateData}
                templateData={templateData}
                presetGkColor={presetGkColor}
              />
              : (
                <p className="empty-text">No player found</p>
              )}
          </div>
        </div>
      )}
      {selectedTemplate === "fcb_results" && (
        <ContentResultManual templateData={templateData} manualEntries={manualEntries} setManualEntries={setManualEntries} isPenalty={effects?.isPenalty} />
      )}
      {selectedTemplate === "fcb_matchday_slider_2" && (
        <ContentSlider2Manual templateData={templateData} manualEntries={manualEntries} setManualEntries={setManualEntries} />
      )}
      {selectedTemplate === "fcb_heatmap" &&
        <InputCheckboxSingle
          key={heatmapField?.id}
          item={heatmapField}
          form={form}
          isCutoutModal={true}
          setFilteredFields={setHeatmapFields}
          setTemplateData={setTemplateData}
          templateData={templateData}
        />
      }
      {!selectedTemplate && (
        <div className="section content-container">
          <img src={Vector} />
          <p className="empty-text">Select a template to begin editing.</p>
        </div>
      )}
    </div>
  );
};

export default ContentTab;
